import { BaseResponseModel, QueryParamsModel } from './../../shared/';
import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IDepartmentModel } from 'src/app/shared/models/department.model';
import { GetOfficerRequest } from 'src/app/shared/models/user.model';
import { ITreeDepartmentOfficer } from 'src/app/shared/models/TreeDepartmentOfficer';

@Injectable()
export class DepartmentService {
  private BASE_URL = environment.base_url;
  constructor(private http: HttpClient) { }

  create(location: IDepartmentModel): Observable<BaseResponseModel<number>> {
    const apiUrl = `${this.BASE_URL}department`;
    return this.http.post<BaseResponseModel<number>>(apiUrl, location);
  }

  delete(id: number): Observable<BaseResponseModel<string>> {
    const apiUrl = `${this.BASE_URL}department/${id}`;
    return this.http.delete<BaseResponseModel<string>>(apiUrl);
  }

  getById(id: number): Observable<BaseResponseModel<IDepartmentModel>> {
    const apiUrl = `${this.BASE_URL}department/${id}`;
    return this.http.get<BaseResponseModel<IDepartmentModel>>(apiUrl);
  }

  update(location: IDepartmentModel): Observable<BaseResponseModel<number>> {
    const apiUrl = `${this.BASE_URL}department`;
    return this.http.put<BaseResponseModel<number>>(apiUrl, location);
  }

  getAll(queryParams: QueryParamsModel): Observable<BaseResponseModel<IDepartmentModel[]>> {
    const apiUrl = `${this.BASE_URL}department`;
    let params = new HttpParams()
    .set('sortOrder', queryParams.sortOrder)
    .set('sortField', queryParams.sortField);

    Object.keys(queryParams.filter).forEach((key) => {
      params = params.set(key, queryParams.filter[key]);
    });

    return this.http.get<BaseResponseModel<IDepartmentModel[]>>(
      apiUrl,
      { params }
    );
  }

  getAllForSelect(): Observable<BaseResponseModel<IDepartmentModel[]>> {
    const apiUrl = `${this.BASE_URL}department/get-all-active`;

    return this.http.get<BaseResponseModel<IDepartmentModel[]>>(apiUrl);
  }

  getDepartmentOfficer(model: GetOfficerRequest): Observable<BaseResponseModel<ITreeDepartmentOfficer[]>> {
    const apiUrl = `${this.BASE_URL}department/get-department-officer`;
    return this.http.post<BaseResponseModel<ITreeDepartmentOfficer[]>>(apiUrl, model);
  }

  patchUpdate(
    id: number,
    department: any
  ): Observable<BaseResponseModel<number>> {
    const apiUrl = `${this.BASE_URL}department/${id}`;
    return this.http.patch<BaseResponseModel<number>>(apiUrl, department);
  }

  updateRepresentative(payload: any): Observable<BaseResponseModel<number>> {
    const apiUrl = `${this.BASE_URL}department/representative`;
    return this.http.put<BaseResponseModel<number>>(apiUrl, payload);
  }

  getSMSAndEmailSetting(): Observable<BaseResponseModel<IDepartmentModel[]>> {
    const apiUrl = `${this.BASE_URL}settings/GetSMSAndEmailSetting`;

    return this.http.get<BaseResponseModel<IDepartmentModel[]>>(apiUrl);
  }

  updateSMSAndEmailSetting(location: IDepartmentModel): Observable<BaseResponseModel<number>> {
    const apiUrl = `${this.BASE_URL}settings/UpdateSMSAndEmailSetting`;
    return this.http.put<BaseResponseModel<number>>(apiUrl, location);
  }

  getAllSMSAndEmailSetting(): Observable<BaseResponseModel<IDepartmentModel[]>> {
    const apiUrl = `${this.BASE_URL}users?sortOrder=asc&sortField=UserName&index=-1&pageSize=5000&filter=`;

    return this.http.get<BaseResponseModel<IDepartmentModel[]>>(apiUrl);
  }
  
}
